/* You must register this file at "website\src\i18n\en-us" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    notifications: {
        menu: {
            index: 'Notifications',
            create: 'New notification',
            list: 'Notifications'
        },
        table_titles: {
            id: 'ID',
            subject: 'Subject',
            type: 'Type',
            user: 'User',
            data: 'Data',
            read_at: 'Read time',
            created_at: 'Creation time',
            setting: 'Show / Delete',
        },
        edit: 'Edit notification'
    }
}
